import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import {blue, green, orange, red} from "@mui/material/colors";
import moment from "moment";

interface IPharmacyListItemProps {
  row: any;
}

const PharmacyListItem:React.FunctionComponent<IPharmacyListItemProps> = ({
  row,
}) => {
  const navigate = useNavigate();

  const getColor: any = () => {
    return {
      APPROVED: {
        color: green[700],
        bgColor: green[200],
      },
      REJECTED: {
        color: red[700],
        bgColor: red[200],
      },
      PENDING: {
        color: blue[700],
        bgColor: blue[200],
      },
      EXPIRED: {
        color: orange[700],
        bgColor: orange[200],
      },
      LICENSE_UPLOADED: {
        color: blue[700],
        bgColor: blue[200],
      }
    }
  }

  return (
    <TableRow
      key={row.name}
      sx={{ cursor: 'pointer', '&:last-child td, &:last-child th': { border: 0 } }}
      onClick={() => navigate(`/pharmacies/${row.id}`)}
    >
      <TableCell component="th" scope="row"> {row.name}</TableCell>      
      <TableCell align="left">{row.email}</TableCell>
      <TableCell align="left">{moment(row.created).format('MM/DD/YYYY hh:mm A')}</TableCell>
      <TableCell align="left">{row.phone}</TableCell>
      <TableCell align="left">{row.user}</TableCell>
      <TableCell align="left">{row.vacationDates || ''}</TableCell>
      <TableCell align="center">
        <Box sx={{
          borderRadius: '16px',
          padding: '8px 16px',
          color: getColor()[row.status.Status.key].color,
          backgroundColor: getColor()[row.status.Status.key].bgColor
        }}>
          {row.status.Status.name}
        </Box>
      </TableCell>
    </TableRow>
  )
}

export default PharmacyListItem;